import * as React from "react";
const SvgAddDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 7, viewBox: "0 0 12 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.78944 4.83785L1.21559 0.191406L0.519531 0.898513L5.44141 5.89851C5.63362 6.09378 5.94525 6.09378 6.13746 5.89851L11.0593 0.898513L10.3633 0.191406L5.78944 4.83785Z", fill: "white", fillOpacity: 0.4, style: {
  fill: "white",
  fillOpacity: 0.4
} }));
export default SvgAddDown;
